module.exports = __webpack_public_path__ + "img/17.8.TSS.ea838654.png";